module.exports = __webpack_public_path__ + "static/media/white-logo.4935873d.png";